import { render, staticRenderFns } from "./SipAccount.vue?vue&type=template&id=473b55b5&scoped=true"
import script from "./SipAccount.vue?vue&type=script&lang=js"
export * from "./SipAccount.vue?vue&type=script&lang=js"
import style0 from "./SipAccount.vue?vue&type=style&index=0&id=473b55b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b55b5",
  null
  
)

export default component.exports